import {apiWithoutToken} from '../../systems/api';
import {API_URL} from './../../systems/globalContant';

export default {
    getPartnerConfig: (data) => apiWithoutToken.post(API_URL.GET_PARTNER_CONFIG, data, {loading: false}),
};